import React from 'react'
import { SVGIconProps } from '../types'
const SvgBlankFile = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="currentColor"
    viewBox="0 -960 960 960"
    {...props}
  >
    <path d="M240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80zm280-520v-200H240v640h480v-440zM240-800v200zv640z" />
  </svg>
)
export default SvgBlankFile
